module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.f7e77a49.eot";